module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Screen-Eye-Savers.39448365.png";